/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs, TabList, TabPanels, TabPanel, Tab } from '@chakra-ui/react'
import React from 'react'
import {Pending} from './pending';
import {Completed} from './completed';
  import {useParams} from 'react-router-dom';

export default function Package({user_id=null})  {

  const {id} = useParams();

  return (

    <>
      <Tabs variant='soft-rounded' colorScheme='rgb(247, 147, 26);'>
        <TabList>
         <Tab style={{color:'#FFFFFF'}}>Pendiente</Tab>
         <Tab style={{color:'#FFFFFF'}}>Solicitado</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
           <Pending user_id={id} / > 
        </TabPanel>
          <TabPanel>
             <Completed user_id={id} / > 
       
        </TabPanel>


        </TabPanels>
      </Tabs>
      </>
  )
}
